// extracted by mini-css-extract-plugin
var _1 = "EmptyContent_root__d5ec4";
export { _1 as "root" }
